import { render, staticRenderFns } from "./CreateUserGroup.vue?vue&type=template&id=3660d225&"
import script from "./CreateUserGroup.vue?vue&type=script&lang=js&"
export * from "./CreateUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserGroup.vue?vue&type=style&index=0&id=3660d225&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports